import { map } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
  },
  record: null,
};

const slice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MEMBERS
    getMembersSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // GET MEMBER
    getMemberSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },

    // CREATE MEMBER
    createMemberSuccess(state, action) {
      const record = action.payload;
      state.isLoading = false;
      state.data = [...state.data, record];
      state.error = false;
    },

    // UPDATE MEMBER
    updateMemberSuccess(state, action) {
      state.record = action.payload;
      const updateRecord = map(state.data, (_record) => {
        if (_record.id === state.record.id) {
          return state.record;
        }
        return _record;
      });

      state.isLoading = false;
      state.data = updateRecord;
      state.params = { ...state.params };
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },

    // REFRESH PARAMS
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getMembers(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/member/', {
        params,
      });
      dispatch(slice.actions.getMembersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getMember(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/member/${id}/`);
      dispatch(slice.actions.getMemberSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createMember(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/member/', record);
      dispatch(slice.actions.createMemberSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function updateMember(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/member/${id}/`, record);
      dispatch(slice.actions.updateMemberSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function partialUpdateMember(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`/member/${id}/`, record);
      dispatch(slice.actions.updateMemberSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
